import { Fraga } from "@/types/riskbedomning";
import { planeringsriskerFragor } from "./planeringsrisker";
import { byggbarhetKonstruktionFragor } from "./byggbarhetKonstruktion";
import { sakerhetSkyddFragor } from "./sakerhetSkydd";
import { etableringOrganisationFragor } from "./etableringOrganisation";
import { specialarbetenFragor } from "./specialarbeten";
import { driftUnderhallFragor } from "./driftUnderhall";
import { specialRiskFragor } from "../specialrisker";
import { elsakerhetFragor } from "./elsakerhet";

// Consolidated byggskede structure with streamlined questions
// Focused on core risks with essential follow-ups only
// TypeScript compilation optimization
export const byggskedeFragorNew: Fraga[] = [
  ...planeringsriskerFragor,        // 4 main questions covering transport, coordination, ergonomics, stability
  ...byggbarhetKonstruktionFragor,   // 5 main questions covering fall risks, cranes, excavation, environment, materials  
  ...sakerhetSkyddFragor,           // 5 main questions covering traffic, barriers, chemicals, first aid, coordination
  ...etableringOrganisationFragor,  // 4 main questions covering establishment, logistics, weather, neighbors
  ...specialarbetenFragor,          // 5 main questions covering OSA, ergonomics, electrical, lighting, floors
  ...driftUnderhallFragor,          // 5 main questions covering access, ergonomics, chemicals, noise, maintenance
  ...specialRiskFragor,             // 13 questions covering särskilda arbetsmiljörisker according to AFS
  ...elsakerhetFragor               // 5 questions: LOTO, elverktyg, ensamarbete, maskinsäkerhet, värme/kyla
  // Total: ~46 main questions with ~220+ follow-ups
];